import React from "react";
import { Box, Typography, Breadcrumbs, Link } from "@mui/material";

export default function PageHeader({ title, subtitle, actions, crumb }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        alignItems: "flex-end",
        justifyContent: "space-between",
        mb: 3,
      }}
    >
      <Box>
        <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
          <Link underline="hover" color="text.secondary" href="#">
            Admin
          </Link>
          <Typography color="text.primary" fontSize={13}>
            {crumb || title}
          </Typography>
        </Breadcrumbs>
        <Typography variant="h4">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: "flex", gap: 1.5 }}>{actions}</Box>}
    </Box>
  );
}
